module.exports = __webpack_public_path__ + "static/media/iconNext.46f32850.svg";